import React from 'react';
import { Button, Center, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { IconArrowLeft } from '@tabler/icons-react';

interface LoadFailedProps {
  /** Куда вернуться; у страниц-списков возвращаться некуда — кнопки нет. */
  onBack?: () => void;
  /** «Повторить» — перезапросить данные страницы, когда ошибка могла быть временной. */
  hasRetry?: boolean;
  message?: string;
}

/** Запрос страницы упал: вместо вечного спиннера или «страница не найдена» — текст и выход. */
export const LoadFailed: React.FC<LoadFailedProps> = ({ onBack, hasRetry, message }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  return (
    <Center mih="40vh">
      <Stack align="center" gap="md">
        <Text c="dimmed">{message ?? t('errors.cantOpen')}</Text>
        <Group>
          {/* Не BackButton: на телефоне он сжимается в иконку, а здесь это главное действие. */}
          {onBack && (
            <Button variant="light" leftSection={<IconArrowLeft size={16} />} onClick={onBack}>
              {t('common.back')}
            </Button>
          )}
          {hasRetry && (
            <Button variant="light" onClick={() => queryClient.refetchQueries({ type: 'active' })}>
              {t('errors.retry')}
            </Button>
          )}
        </Group>
      </Stack>
    </Center>
  );
};
